import { render, staticRenderFns } from "./pushTenantList.vue?vue&type=template&id=c47af2ce"
import script from "./pushTenantList.vue?vue&type=script&lang=js"
export * from "./pushTenantList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports